module.exports = {
  title: 'Video',
  context: {
    image: {
      src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/cooking.jpg?mtime=20210623075136&focal=none',
      alt: 'image'
    },
    video: {
      hash: 'axbg48fg0',
      title: 'YouTube Video Title',
      url: 'https://www.youtube.com/watch?v=Nep1qytq9JM'
    }
  },
  variants: [
    {
      name: 'vimeo',
      context: {
        image: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/cooking.jpg?mtime=20210623075136&focal=none',
          alt: 'image'
        },
        video: {
          hash: 'axbg48fg0',
          title: 'Vimeo Video Title',
          url: 'https://vimeo.com/99426212'
        }
      }
    },
    {
      name: 'has-description',
      context: {
        type: 'has-description',
        image: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/cooking.jpg?mtime=20210623075136&focal=none',
          alt: 'image'
        },
        video: {
          hash: 'axbg48fg0',
          title: 'Vimeo Video Title',
          url: 'https://vimeo.com/99426212'
        },
        description: '"We offer a variety of services to people within the full spectrum of types of disabilities. Everyday our we are committed to people with disabilities to help them succeed in their daily lives."'
      }
    }
  ]
}
